jQuery(function($){
    setInterval(function(){
        //setTimeout(function(){
        jQuery('a[href="https://accessibe.com/blog/knowledgebase/screen-reader-guide"]').attr('aria-label','Screen Reader Guide');
        jQuery('#Slider-template--16887416848600__4cea8cdc-ab53-4f52-9020-8e9a1eb08bfc').attr('tabindex','0');
        //jQuery('#Slider-template--16887416848600__4cea8cdc-ab53-4f52-9020-8e9a1eb08bfc')
        jQuery('#Slider-template--16887416848600__featured_collection').removeAttr('role');
          
        },2500);
        //begin updates to alternate text, title, and aria-label if needed only
	var imgCnt = 1;
	var proImg = 1;
    var h1Txt = jQuery('.product-single__title').html();
	jQuery('img').each(function () {
		var curAlt = jQuery(this).attr('alt');
		var curTitle = jQuery(this).attr('title');
		var curAriaLbl = jQuery(this).attr('aria-label');
		//no alt text or empty alt text or undefined
		if (!curAlt || curAlt == '' || curAlt == 'undefined') {
			jQuery(this).attr('alt', ''); //decorative	
			if (jQuery(this).hasClass('zoomImg')) {
				jQuery(this).attr('alt', 'Current Product Image #' + proImg);
				proImg++;
			} else if (jQuery(this).parent('a')) {
				if (jQuery(this).parent().hasClass('product-single__thumbnail')) {
					jQuery(this).attr('alt', 'product Image #' + proImg);
					proImg++;
				} else {
					jQuery(this).attr('alt', 'decorative Image #' + imgCnt);
					imgCnt++;
                }
			} else {
				//if empty then should not contain title or aria-label
				jQuery(this).removeAttr('aria-label');
				jQuery(this).removeAttr('title');
			}

		} else {
			
			if (jQuery(this).hasClass('zoomImg')) {
				
              if(h1Txt.includes( curAlt )){
				    jQuery(this).attr('alt', curAlt + ' Enlarged Product Image #' + proImg);
					proImg++;
                  } else {
                  	jQuery(this).attr('alt', curAlt);
                  }
			} else if (jQuery(this).parent('a')) {
				if (jQuery(this).parent().hasClass('product-single__thumbnail')) {
                  if(h1Txt.includes( curAlt )){
					jQuery(this).attr('alt', curAlt + ' Thumbnail Product Image #' + proImg);
                    proImg++;
                  } else {
                  	jQuery(this).attr('alt', curAlt);
                  }
					
				} else {
					jQuery(this).attr('alt', curAlt);
				}
			} else {
				//alt present so we should leave alt alone
				jQuery(this).attr('alt', curAlt);
				//if title present add an aria-label as well
				if (!curTitle || curTitle == '' || curTitle == 'undefined') { }
				else {
					//first check to make sure it doesn't already have aria-label
					if (!curAriaLbl || curAriaLbl == '' || curAriaLbl == 'undefined') {
						jQuery(this).attr('aria-label', curTitle);
					}
				}
			}
		}
		imgCnt++;
	});
	//end updates to alternate text, title, and aria-label if needed only
        //landmarks
        var navCnt = 1;
		jQuery('nav').each( function(){
			jQuery(this).attr('aria-label','Navigation Menu #'+navCnt);
			navCnt++;
		});
      setTimeout(function(){
        //Fix carousels ul/li - can not use role on ul or li without changing purpose of list
        
        jQuery('ul.slider').each(function(){
          var roleParm = String(jQuery(this).attr('role'));
          var ariaLbl = String(jQuery(this).attr('aria-label'));
          jQuery(this).removeAttr('role').removeAttr('aria-label');
          jQuery(this).parent().attr('role','region').attr('aria-label',ariaLbl);
        });    
        jQuery('ul').each(function(){
          var curId = String(jQuery(this).attr('id'));
          if(curId.includes('Slider-template') && !jQuery(this).hasClass('slider')){
            var roleParm = String(jQuery(this).attr('role'));
          var ariaLbl = String(jQuery(this).attr('aria-label'));
          jQuery(this).removeAttr('role').removeAttr('aria-label');
          jQuery(this).parent().attr('role','region').attr('aria-label',ariaLbl);
          }
        });
        },1800); //1.8 sec delay      
       setTimeout(function(){        
        //do not set roles on images
        jQuery('img').each(function(){         
            jQuery(this).removeAttr('role');          
        });
         //button within a button - remove one
         jQuery('[data-testid="GooglePay-button"]').each(function(){
           jQuery(this).removeAttr('role').removeAttr('tabindex');
         });
         //heading levels
         jQuery('h2[aria-level="3"]').each(function(){
           jQuery(this).removeAttr('aria-level');
         });

         //fix aira and lists
         jQuery('slider-component').each(function(){
           jQuery(this).attr('role','region');
         });
         jQuery('.policies').each(function(){
           jQuery(this).find('li').each(function(){
           jQuery(this).removeAttr('role');
         });
           jQuery('ul').each(function(){
             jQuery(this).removeAttr('role').find('li').each(function(){
               jQuery(this).removeAttr('role');
             });
           });
         });

         jQuery('.section-template--16887416815832__main-padding').find('td').each(function(){
           jQuery(this).find('a').each(function(){
             jQuery(this).addClass('tableLink');
           });
         });
         var rowCnt = 0;
         jQuery('.section-template--16887416815832__main-padding').find('tr').each(function(){
           if(rowCnt === 0){
             jQuery(this).find('td').each(function(){
               jQuery(this).attr('scope','col');
                var el = jQuery(this),
                    html = el.html(),
                    attrs = {
                        "id": el.attr('id'),
                        "class": el.attr('class'),
                        "scope": el.attr('scope'),
                        "bgcolor": el.attr('bgcolor'),
                        "width": el.attr('width')
                    };
                console.log('Replacing address select link tags: ' + el.prop('tagName'));
                el.replaceWith(jQuery('<th></th>').html(html).attr(attrs));
             });
           }
           rowCnt++;
         });
         jQuery('h3').each(function(){
           jQuery(this).removeAttr('role');
         });
        },2500); //2.5 sec delay
      });